module.exports = __webpack_public_path__ + "img/gh_pic07-0fa7a0.png";